<mat-card class="filter settingHeader">
    <div class="name">
        Manage Equipment
    </div>
    <div class="quickAction">
        <mat-form-field class="example-form-field" appearence="fill" >
            <mat-label>Search Equipment</mat-label>
            <input matInput type="text" >            
          </mat-form-field>
        <div class="">
            <button mat-flat-button color="primary" (click)="openCaseDetail()" > Add Equipment </button>
        </div>
    </div>
</mat-card>

<div class="listingHolder">
    <table class="table">
        <tr>
            <th>Name</th>
            <th class="available">Icon</th>
            <th class="available" >Prep Time</th>
            <th class="available" >Clean Up Time</th>
            <th class="available" >Items</th>
            <th class="available" >Moveable</th>
            <!-- <th class="available" >Rooms</th> -->
            <th class="available" >Available</th>
            <th class="action" >Action</th>
        </tr>
        <tr>
            <td>Patient Oxygen Mask</td>
            <td>
                <mat-icon>dvr</mat-icon>
            </td>
            <td>10 mine</td>
            <td>10 min</td>
            <td>5</td>
            <td>Yes</td>
            <!-- <td>F1-3</td> -->
            <td>
                <mat-slide-toggle color="primary" [(ngModel)]="isChecked" ></mat-slide-toggle>
            </td>
            <td>
                <div class="btnAction">
                    <button mat-icon-button color="primary"  >
                        <mat-icon>create</mat-icon>
                    </button>
                    <button mat-icon-button color="primary"  >
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>
            </td>
        </tr>
    </table>
</div>

<app-add-equipment [ngClass]="{'open': showCaseDetail}"  (closeCaseDetail)=getCloseCaseDetail($event)  ></app-add-equipment>